const isPositive = (value) => Number.isFinite(Number(value)) && Number(value) > 0;
const isNonNegativeInteger = (value) =>
  value !== "" && Number.isInteger(Number(value)) && Number(value) >= 0;

const getShippingType = (group) => {
  if (group?.UseFedexShipping) return "fedex";
  if (group?.CustomShipping) return "custom";
  return "standard";
};

export const normalizeProductGroupDraft = (group) => ({
  ProductGroupName: group?.ProductGroupName ?? "",
  ProductGroupCategoryID:
    Number(group?.ProductGroupCategoryID) > 0
      ? Number(group.ProductGroupCategoryID)
      : null,
  QCode: group?.QCode ?? "",
  InvoicePrefix: group?.InvoicePrefix ?? "",
  IsActive: group?.IsActive === undefined ? true : Boolean(group?.IsActive),
  Serialized: Boolean(group?.Serialized),
  IVR: Boolean(group?.IVR),
  RequireProcedureInfo: Boolean(group?.RequireProcedureInfo),
  SignatureRequiredForDelivery: Boolean(group?.SignatureRequiredForDelivery),
  CollectPayment: Boolean(group?.CollectPayment),
  EnableOpenOrder: Boolean(group?.EnableOpenOrder),
  EnableCommissionContract: Boolean(group?.EnableCommissionContract),
  // IncludeOnDPA is intentionally left out of the draft: the flag has no
  // consumer, so the save payload omits it and the backend preserves it.
  IncludeOnEnrollmentForm: Boolean(group?.IncludeOnEnrollmentForm),
  OpenOrderImageBlobName: group?.OpenOrderImageBlobName ?? null,
  OpenOrderImageFileName: group?.OpenOrderImageFileName ?? "",
  OpenOrderImageContentType: group?.OpenOrderImageContentType ?? null,
  ShippingType: getShippingType(group),
  ShippingCategoryID: Number(group?.ShippingCategoryID) || null,
  PricingType: group?.PricingType === "custom" ? "custom" : "rate",
  Rate: group?.Rate ?? "",
});

export const buildProductGroupDetailRequest = (payload, imageFile) => {
  if (!imageFile) return { body: payload, config: undefined };
  const body = new FormData();
  body.append("payload", JSON.stringify(payload));
  body.append("openOrderImage", imageFile);
  return {
    body,
    config: { headers: { "Content-Type": "multipart/form-data" } },
  };
};

export const hasCompleteFedexMetadata = (product) => {
  if (!isPositive(product?.Weight)) return false;
  if (product?.CustomPackaging) {
    return ["CustomBoxWidth", "CustomBoxLength", "CustomBoxHeight", "CustomBoxFits"].every(
      (key) => isPositive(product?.[key]) && (key !== "CustomBoxFits" || Number.isInteger(Number(product?.[key]))),
    );
  }
  return ["OneRateXS", "OneRateS", "OneRateM", "OneRateL", "OneRateXL"].every(
    (key) => isNonNegativeInteger(product?.[key]),
  );
};
